import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {DesignModule} from './design/design.module';
import {SharedDialogModule} from './dialog/shared-dialog.module';
import {LayoutModule} from './layout/layout.module';
import {MaterialModule} from './material/material.module';
import {MobileModule} from './mobile/mobile.module';
import {NavbarModule} from './navbar/navbar.module';
import {PipesModule} from './pipes/pipes.module';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {ListViewsModule} from './list-views/list-views.module';
import {SharedProjectsModule} from './projects/shared-projects.module';
import {OphIconModule} from './design/oph-icon/oph-icon.module';

@NgModule({
  imports: [
    CommonModule,
    DesignModule,
    FormsModule,
    LayoutModule,
    MaterialModule,
    MatSnackBarModule,
    NavbarModule,
    PipesModule,
    ReactiveFormsModule,
    RouterModule,
    MobileModule,
    SharedDialogModule,
    ListViewsModule,
    SharedProjectsModule,
    OphIconModule,
  ],
  exports: [
    CommonModule,
    DesignModule,
    FormsModule,
    LayoutModule,
    MaterialModule,
    MatSnackBarModule,
    NavbarModule,
    PipesModule,
    ReactiveFormsModule,
    RouterModule,
    MobileModule,
    SharedDialogModule,
  ],
})
export class SharedModule {}
